/* TSF · colores en las tarjetas de producto y paginación de los testimonios del home. */
(function () {
  if (window.__tsfCards) return;
  window.__tsfCards = true;

  /* ---------------- Colores en tarjetas ---------------- */
  const pick = (sw) => {
    const card = sw.closest('.product-card-wrapper, .card-wrapper');
    if (!card) return;
    const img = card.querySelector('.card__media img');
    card.classList.add('tsf-sw-picked');
    if (img && sw.dataset.img && img.getAttribute('src') !== sw.dataset.img) {
      // se precarga y recién ahí se cambia, para que nunca quede en blanco
      const next = new Image();
      next.onload = () => {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = sw.dataset.img;
      };
      next.src = sw.dataset.img;
    }
    card.querySelectorAll('.tsf-sw').forEach((s) => s.classList.toggle('is-on', s === sw));
  };
  const canHover = window.matchMedia('(hover: hover)');
  document.addEventListener('mouseover', (e) => {
    const sw = e.target.closest('.tsf-sw[data-img]');
    if (sw && canHover.matches) pick(sw);
  });
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.tsf-sw');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    if (sw.dataset.img) pick(sw);
  }, true);

  /* ---------------- Testimonios del home, por páginas ---------------- */
  function initWall(wall) {
    const items = Array.from(wall.querySelectorAll('.tsfh-q'));
    const pager = wall.parentElement.querySelector('[data-tsfh-pager]');
    if (!items.length || !pager) return;
    const perPage = () => (window.matchMedia('(min-width: 1100px)').matches ? 6 : window.matchMedia('(min-width: 750px)').matches ? 4 : 1);
    let per = perPage();
    let page = 0;
    const chev = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;

    // En escritorio/tablet el bloque toma la altura de la página más alta: así nada se mueve al pasar de página
    const lockHeight = () => {
      wall.style.minHeight = '';
      if (per === 1) return;
      const pages = Math.ceil(items.length / per);
      let max = 0;
      for (let p = 0; p < pages; p++) {
        items.forEach((el, i) => { el.hidden = Math.floor(i / per) !== p; });
        max = Math.max(max, wall.offsetHeight);
      }
      wall.style.minHeight = `${max}px`;
    };

    const render = (scroll) => {
      const pages = Math.ceil(items.length / per);
      page = Math.max(0, Math.min(page, pages - 1));
      items.forEach((el, i) => { el.hidden = Math.floor(i / per) !== page; });
      wall.classList.remove('is-turning');
      void wall.offsetWidth;
      wall.classList.add('is-turning');
      const from = page * per + 1;
      const to = Math.min(items.length, from + per - 1);
      let nums = '';
      if (pages <= 7) {
        for (let p = 0; p < pages; p++) {
          nums += `<button type="button" class="tsfh-pager__num" data-p="${p}"${p === page ? ' aria-current="page"' : ''} aria-label="Page ${p + 1}">${p + 1}</button>`;
        }
      } else {
        nums = `<span class="tsfh-pager__count">${page + 1} / ${pages}</span>`;
      }
      pager.innerHTML = `
        <button type="button" class="tsfh-pager__arrow" data-p="${page - 1}" aria-label="Previous"${page === 0 ? ' disabled' : ''}>${chev('m14.5 5-7 7 7 7')}</button>
        <div class="tsfh-pager__nums">${nums}</div>
        <button type="button" class="tsfh-pager__arrow" data-p="${page + 1}" aria-label="Next"${page >= pages - 1 ? ' disabled' : ''}>${chev('m9.5 5 7 7-7 7')}</button>
        <p class="tsfh-pager__info">${per === 1 ? `Testimonial ${from} of ${items.length}` : `Showing ${from}–${to} of ${items.length}`}</p>`;
      if (scroll) {
        const top = pager.getBoundingClientRect().top;
        if (top < 70) pager.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    pager.addEventListener('click', (e) => {
      const b = e.target.closest('[data-p]');
      if (!b || b.disabled) return;
      page = +b.dataset.p;
      render(true);
    });
    // deslizar con el dedo en móvil
    let x0 = null;
    wall.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    wall.addEventListener('touchend', (e) => {
      if (x0 == null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 50) return;
      page += dx < 0 ? 1 : -1;
      render(false);
    }, { passive: true });
    window.addEventListener('resize', () => {
      const n = perPage();
      if (n === per) return;
      const first = page * per;
      per = n;
      page = Math.floor(first / per);
      lockHeight();
      render(false);
    });
    lockHeight();
    render(false);
    // las fotos cargan después: se vuelve a medir una vez que están
    wall.querySelectorAll('img').forEach((img) => img.complete || img.addEventListener('load', () => { lockHeight(); render(false); }, { once: true }));
  }
  const init = () => document.querySelectorAll('.tsfh-wall[data-paged]').forEach(initWall);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
